<template>
    <div :class="{'hold-transition' : true, 'sidebar-mini' : true, 'layout-fixed' : true, 'sidebar-open': mobileMenuActive}" >
    <div id="sidebar-overlay" :style="{'display': mobileMenuActive ? 'block' : 'none'}" @click="closeMobileMenu()"></div>
        <div :class="{'wrapper' : true, 'dark-mode' : store.dark_mode}">

            <!-- Navbar -->
            <nav class="main-header navbar navbar-expand navbar-white navbar-light">
                <!-- Left navbar links -->
                <ul id="top_lnav" class="navbar-nav">
                    <li class="nav-item">
                        <a class="nav-link" @click="openMobileMenu()">
                            <font-awesome-icon icon="fa fa-bars" />
                        </a>
                    </li>
                </ul>

                <!-- Right navbar links -->
                <ul class="navbar-nav mr-auto-navbav">
                    <!-- Messages Dropdown Menu -->
                     <li class="nav-item dropdown" style="display: none;">
                        <a class="nav-link" data-toggle="dropdown" href="#">
                            <i class="far fa-comments"></i>
                            <font-awesome-icon icon="fa-regular fa-comments" />
                            <span class="badge badge-danger navbar-badge">3</span>
                        </a>
                        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                            <a href="#" class="dropdown-item">
                                <!-- Message Start -->
                                <div class="media">
                                    <img src="dist/img/user1-128x128.jpg" alt="User Avatar" class="img-size-50 mr-3 img-circle">
                                    <div class="media-body">
                                        <h3 class="dropdown-item-title">
                                            Brad Diesel
                                            <span class="float-right text-sm text-danger"><i class="fas fa-star"></i></span>
                                        </h3>
                                        <p class="text-sm">Call me whenever you can...</p>
                                        <p class="text-sm text-muted"><i class="far fa-clock mr-1"></i> 4 Hours Ago</p>
                                    </div>
                                </div>
                                <!-- Message End -->
                            </a>
                            <div class="dropdown-divider"></div>
                            <a href="#" class="dropdown-item">
                                <!-- Message Start -->
                                <div class="media">
                                    <img src="dist/img/user8-128x128.jpg" alt="User Avatar" class="img-size-50 img-circle mr-3">
                                    <div class="media-body">
                                        <h3 class="dropdown-item-title">
                                            John Pierce
                                            <span class="float-right text-sm text-muted"><i class="fas fa-star"></i></span>
                                        </h3>
                                        <p class="text-sm">I got your message bro</p>
                                        <p class="text-sm text-muted"><i class="far fa-clock mr-1"></i> 4 Hours Ago</p>
                                    </div>
                                </div>
                                <!-- Message End -->
                            </a>
                            <div class="dropdown-divider"></div>
                            <a href="#" class="dropdown-item">
                                <!-- Message Start -->
                                <div class="media">
                                    <img src="dist/img/user3-128x128.jpg" alt="User Avatar" class="img-size-50 img-circle mr-3">
                                    <div class="media-body">
                                        <h3 class="dropdown-item-title">
                                            Nora Silvester
                                            <span class="float-right text-sm text-warning"><i class="fas fa-star"></i></span>
                                        </h3>
                                        <p class="text-sm">The subject goes here</p>
                                        <p class="text-sm text-muted"><i class="far fa-clock mr-1"></i> 4 Hours Ago</p>
                                    </div>
                                </div>
                                <!-- Message End -->
                            </a>
                            <div class="dropdown-divider"></div>
                            <a href="#" class="dropdown-item dropdown-footer">See All Messages</a>
                        </div>
                    </li>
                    <!-- Notifications Dropdown Menu -->
                    <li class="nav-item dropdown" style="display: none;">
                        <a class="nav-link" data-toggle="dropdown" href="#">
                            <font-awesome-icon icon="fa-regular fa-bell"/>
                            <span class="badge badge-warning navbar-badge">15</span>
                        </a>
                        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                            <span class="dropdown-item dropdown-header">15 Notifications</span>
                            <div class="dropdown-divider"></div>
                            <a href="#" class="dropdown-item">
                                <i class="fas fa-envelope mr-2"></i> 4 new messages
                                <span class="float-right text-muted text-sm">3 mins</span>
                            </a>
                            <div class="dropdown-divider"></div>
                            <a href="#" class="dropdown-item">
                                <i class="fas fa-users mr-2"></i> 8 friend requests
                                <span class="float-right text-muted text-sm">12 hours</span>
                            </a>
                            <div class="dropdown-divider"></div>
                            <a href="#" class="dropdown-item">
                                <i class="fas fa-file mr-2"></i> 3 new reports
                                <span class="float-right text-muted text-sm">2 days</span>
                            </a>
                            <div class="dropdown-divider"></div>
                            <a href="#" class="dropdown-item dropdown-footer">See All Notifications</a>
                        </div>
                    </li>
                    <li class="nav-item">
                        <div class="nav-link pointer" id="change_mode" data-widget="control-sidebar" data-slide="true">
                            <!-- <font-awesome-icon icon="fa-regular fa-moon" class="dark" />
                            <font-awesome-icon icon="fa-regular fa-sun" class="light" /> -->
                            <a href="javascript:void(0)" v-if="!store.dark_mode" @click="changeMode(true)" class="dark" title="תצוגת לילה">
                                <font-awesome-icon icon="fa fa-moon" />
                            </a>
                            <a href="javascript:void(0)" v-if="store.dark_mode" @click="changeMode(false)" class="light"  title="תצוגת יום">
                                <font-awesome-icon icon="fa fa-sun" />
                            </a>
                        </div>
                    </li>
                    <li class="nav-item">
                        <a href="javascript:void(0)" @click="doLogout()" class="nav-link" title="התנתקות">
                            <font-awesome-icon icon="fa fa-right-from-bracket" />
                        </a>
                    </li>

                </ul>
            </nav>
            <!-- /.navbar -->

            <!-- Main Sidebar Container -->
            <aside :class="{'main-sidebar': true, 'sidebar-light-primary' : !store.dark_mode, 'sidebar-dark-primary' : store.dark_mode, 'elevation-4' : true}">
                <!-- Brand Logo -->
                <router-link to="/" class="brand-link">
                        <v-img src="@/assets/logo2.png" id="logo" />
                </router-link>

                <!-- Sidebar -->
                <div class="sidebar">
                    <!-- Sidebar user panel (optional) -->
                    <div class="user-panel mt-3 pb-3 mb-3 d-flex">
                        <div class="image">
                            <img :src="store.user.user_image" class="img-circle" :alt="store.user.user_fname + ' ' + store.user.user_lname">
                        </div>
                        <div class="info">
                            <a href="#" class="d-block">{{store.user.user_fname}} {{store.user.user_lname}}</a>
                        </div>
                    </div>

                    <!-- Sidebar Menu -->
                    <nav class="mt-2">
                        <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
                           <li class="nav-item" v-for="item in menu" :key="item.name">
                                <router-link :to="{name: item.route}" class="nav-link" exact-active-class="active" v-if="item.visible && store.user.user_permission >= item.permission">
                                    <p>
                                        <font-awesome-icon :icon="item.icon" />
                                        &nbsp;
                                        {{item.name}}
                                        
                                    </p>
                                </router-link>
                            </li>
                        </ul>
                    </nav>
                    <!-- /.sidebar-menu -->
                </div>
                <!-- /.sidebar -->
                
            </aside>

            <!-- Content Wrapper. Contains page content -->
            <div class="content-wrapper">
                <!-- Content Header (Page header) -->
                <div class="content-header">
                    <div class="container-fluid">
                        <div class="row mb-2">
                            <div class="col-sm-6">
                                <!-- <h1 class="m-0 text-dark"><font-awesome-icon :icon="menu[$route.name].icon" /> {{menu[$route.name].name}}</h1> -->
                            </div>
                            <!-- <div class="col-sm-6">
                                <ol class="breadcrumb float-sm-left">
                                    <li class="breadcrumb-item"><a href="#">Home</a></li>
                                    <li class="breadcrumb-item active">Dashboard v1</li>
                                </ol>
                            </div> -->
                        </div><!-- /.row -->
                    </div><!-- /.container-fluid -->
                </div>
                <!-- /.content-header -->

                <!-- Main content -->
                <section class="content">
                    <div class="container-fluid">
                        <router-view/>
                    </div>
                    <!-- /.row (main row) -->
                </section>
                <!-- /.content -->
            </div>
            <!-- /.content-wrapper -->
            <footer class="main-footer">
                <strong>Copyright &copy;</strong>
                All rights reserved 
                <div class="float-left d-none d-sm-inline-block">
                    Powered by <a href="https://rwolf.co.il/" target="_blank">Roi Wolf</a>
                </div>
            </footer>

            <!-- Control Sidebar -->
            <aside class="control-sidebar control-sidebar-dark">
                <!-- Control sidebar content goes here -->
            </aside>
            <!-- /.control-sidebar -->
        </div>

    </div>
</template>
<style scoped>
    /*@import '@/assets/admin-lte/plugins/overlayScrollbars/css/OverlayScrollbars.min.css';
    @import 'overlayscrollbars/css/OverlayScrollbars.css';*/

    .sidebar {
        height: auto !important;
    }
    
    /*.scrolly-bar {
        display: none !important;
    }*/
    
    .scrolly-bar.axis-y {
        left: 0;
        right: auto !important;
    }
    
    #change_mode .light{
        color: #e4bc3f;
    }
    #change_mode .dark{
        color: #7D7B67;
    }
    
    .user-panel img {
        width: 2.4rem;
    }

    .user-panel .info {
        padding: 8px 5px 5px 10px
    }
    
    .user-panel .image {
        padding-left: 4px;
    }
    
    #logo {
        width: 100px;
    }
    #top_lnav {
        display: none;
    }
    
    @media only screen and (max-width: 767px) {
        #top_lnav {
            display: block;
        }
    }
    
    
    @media print {

        footer.main-footer {
            display: none;
        }

    }
    
</style>
<!--     <router-view/> -->
<script>
   //import jQuery from 'jquery'
   import '@/assets/admin-lte/more/bootstrap.min.js';  
   import {logout} from '@/utils.js'
   import {store} from '@/store'

   //import '@/assets/admin-lte/plugins/overlayScrollbars/js/jquery.overlayScrollbars.min.js';  
/*import Vue from 'vue';
import { OverlayScrollbarsPlugin } from 'overlayscrollbars-vue'*/
   //import '@/assets/admin-lte/dist/js/adminlte.js';  

    //import '@/assets/test.js';
    //import '@/assets/admin-lte/plugins/chart.js/Chart.min.js';
    //import '@/assets/admin-lte/plugins/sparklines/sparkline.js';
/*const $ = jQuery;
window.$ = $;
/*$( document ).ready(function() {
    alert(1);
});*/
export default {
    components: {
    },
    mounted() {
        //document.title = "About Us"

    },
    data() {
        return {
            store,
            mobileMenuActive: false,
            'menu': {
                'home': {
                    'name': 'עמוד הבית',
                    'icon': 'fa-house',
                    'route': 'home',
                    'permission': 1,
                    'visible': true,
                },
                'reservation_add': {
                    'name': 'הזמנה חדשה',
                    'icon': 'fa-plus',
                    'route': 'reservation_add',
                    'permission': 1,
                    'visible': true,
                },
                'reservation_list': {
                    'name': 'סיכום כללי',
                    'icon': 'fa-bars',
                    'route': 'reservation_list',
                    'permission': 1,
                    'visible': true,
                },
                'reservation_cook': {
                    'name': 'סיכום טבחים',
                    'icon': 'fa-utensils',
                    'route': 'reservation_cook',
                    'permission': 3,
                    'visible': true,
                },
                'reservation_packing': {
                    'name': 'סיכום אורזים',
                    'icon': 'fa-box-open',
                    'route': 'reservation_packing',
                    'permission': 3,
                    'visible': true,
                },
                'reservation_factory': {
                    'name': 'סיכום מפעלים',
                    'icon': 'fa-industry',
                    'route': 'reservation_factory',
                    'permission': 3,
                    'visible': true,
                },
                'product_cost': {
                    'name': 'עלויות מנות',
                    'icon': 'fa-money-bill-1',
                    'route': 'product_cost',
                    'permission': 3,
                    'visible': true,
                },
                'menu': {
                    'name': 'ניהול תפריטים',
                    'icon': 'fa-book',
                    'route': 'menu',
                    'permission': 3,
                    'visible': true,
                },
                'product': {
                    'name': 'מנות',
                    'icon': 'fa-bowl-food',
                    'route': 'product',
                    'permission': 3,
                    'visible': true,
                },
                'ingredient_crud': {
                    'name': 'רכיבים',
                    'icon': 'fa-pepper-hot',
                    'route': 'ingredient_crud',
                    'permission': 7,
                    'visible': true,
                },    
                'factory_crud': {
                    'name': 'ניהול מפעלים',
                    'icon': 'fa-industry',
                    'route': 'factory_crud',
                    'permission': 7,
                    'visible': true,
                },       
               'user_crud': {
                    'name': 'ניהול משתמשים',
                    'icon': 'fa-user-gear',
                    'route': 'user_crud',
                    'permission': 7,
                    'visible': true,
                },
                'reservation_edit': {
                    'name': 'עדכון הזמנה',
                    'icon': 'fa-plus',
                    'route': 'reservation_edit',
                    'permission': 1,
                    'visible': false,
                },
            }
        }
    },
    methods: {
        doLogout() {
            logout();
        },
        changeMode(bol) {
            store.dark_mode = bol;
            if (bol) {
                document.body.classList.add('dark-mode');
            } else {
                document.body.classList.remove('dark-mode');
            }
        },
        openMobileMenu() {
            this.mobileMenuActive = true;
            /*if (!this.mobileMenuActive) {
              this.mobileMenuActive = true;
            } else {
              this.mobileMenuActive = false;
            }*/
        },
        closeMobileMenu() {
            this.mobileMenuActive = false;
        }
        
    }
}
</script>